import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import RunningClubEventListPage from './running-club-event-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Running Club Events">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/running-clubs">RunningClubs</Breadcrumb.Item>
            <Breadcrumb.Item active>Events</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <RunningClubEventListPage />
    </Panel>
  );
};

export default Page;
